<template>
  <h1 v-if="isLoading" />
  <main v-else-if="currentProduct !== null" class="view-product-details full-height d-flex flex-column pb-5" itemscope itemtype="http://schema.org/Product">
    <ProductBanner :product="currentProduct" />
    <article class="col-lg-9 col-md-10 col-sm-11 col-xxs-12 mx-auto p-0 game-detail">
      <ProductSummary :product="currentProduct" />
      <!-- <div class="d-flex flex-sm-row flex-xxs-column justify-content-between px-sm-0 px-xxs-3"> -->
        <!-- <ProductAndroidVersion :product="product1"></ProductAndroidVersion> -->
        <!-- <ProductPermissions :product="product1"></ProductPermissions> -->
        <!-- <ProductBrowserSupport :product="product1"></ProductBrowserSupport> -->
      <!-- </div> -->
      <ProductScreenshots v-if="currentProduct.screenShots && currentProduct.screenShots.length > 0" :product="currentProduct" />
      <SimpleCollectionHost
        v-if="currentProduct.collections && currentProduct.collections.length > 0"
        :configurations="{id: currentProduct.collections[0].id}"
        :title="$t('product.similarProducts', {products: this.globalResources.productTranslation.Plural})"
      />
      <ProductLicense :title="currentProduct.name" />
    </article>
  </main>
</template>

<script>
import Vue from 'vue'
import ProductBanner from '@/components/ProductBanner.vue'
import ProductSummary from '@/components/ProductSummary.vue'
import ProductPermissions from '@/components/ProductPermissions.vue'
import ProductAndroidVersion from '@/components/ProductAndroidVersion.vue'
import ProductScreenshots from '@/components/ProductScreenshots.vue'
import SimpleCollectionHost from '@/components/SimpleCollectionHost.vue'
import ProductLicense from '@/components/ProductLicense.vue'
import UserReview from '@/components/UserReview.vue'
import ProductBrowserSupport from '@/components/ProductBrowserSupport.vue'

import { mapGetters, mapActions } from 'vuex'

export default Vue.extend({
  name: 'GameDetail',
  components: {
    ProductBanner,
    ProductSummary,
    ProductScreenshots,
    SimpleCollectionHost,
    ProductLicense,
    UserReview
    // ProductBrowserSupport,
    // ProductPermissions,
    // ProductAndroidVersion
  },
  data () {
    return {
      isLoading: true,
      productId: 0
    }
  },
  computed: {
    ...mapGetters({
      product: 'productCatalog/product'
    }),
    currentProduct () {
      return this.product(this.productId)
    }
  },
  watch: {
    '$route.params.id': function () {
      this.loadProductInfo()
    }
  },
  created () {
    this.loadProductInfo()
  },
  methods: {
    ...mapActions({
      loadProduct: 'productCatalog/loadProduct'
    }),
    loadProductInfo () {
      this.isLoading = true
      window.scrollTo(0, 0)
      this.productId = Number(this.$route.params.id)
      if (this.currentProduct === null) {
        this.loadProduct(this.productId)
          .then(response => {
            if (this.currentProduct === null) {
              this.$router.push({ name: '404' })
            } else {
              this.isLoading = false
            }
          })
          .catch(error => {
            if (error) {
              this.$router.push({ name: '404' })
            }
          })
      } else {
        this.isLoading = false
      }
    }
  }
})
</script>
